/**
 * Stage helpers for OrderView — extracted from the page component
 * to keep the JSX file focused on rendering.
 */

export const STAGES = [
    { key: "pending", label: "Payment confirmed" },
    { key: "analyzing_photo", label: "Studying the photo" },
    { key: "generating_story", label: "Writing your story" },
    { key: "story_generated", label: "Story drafted" },
    { key: "images_generating", label: "Illustrating 24 pages" },
    { key: "generating_cover", label: "Painting the cover" },
    { key: "assembling_pdf", label: "Binding the book" },
    { key: "complete", label: "Print-ready" },
    { key: "submitting_to_lulu", label: "Sending to the printer" },
    { key: "sent_to_print", label: "Sent to printer" },
    { key: "shipped", label: "Shipped" },
];

const STAGE_INDEX = STAGES.reduce((acc, s, i) => ({ ...acc, [s.key]: i }), {});
// Note: `complete` and `submitting_to_lulu` are TRANSIENT states between PDF
// assembly and Lulu submission — the pipeline still has work to do, so we keep
// showing the progress timeline (not the "your book is ready" banner) for them.
// The banner only appears once the Lulu print job is actually accepted.
const COMPLETE_STATUSES = ["sent_to_print", "shipped"];
const SHIPPING_VISIBLE_STATUSES = ["sent_to_print", "shipped"];

export function statusToIndex(status) {
    return STAGE_INDEX[status] ?? 0;
}

export function isOrderComplete(status) {
    return COMPLETE_STATUSES.includes(status);
}

export function isShippingVisible(order) {
    if (!order) return false;
    return SHIPPING_VISIBLE_STATUSES.includes(order.status) || Boolean(order.lulu_tracking_id);
}
